import { resolve } from "path";

type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;
type LoggerLike = Pick<Console, "warn">;

const PLATFORM_ANALYTICS_SCRIPT_PATH = "/_gencow/analytics.js";
const PLATFORM_ANALYTICS_EVENT_PATH = "/_gencow/analytics/event";
const PLATFORM_ANALYTICS_SCRIPT_TAG = `<script defer src="${PLATFORM_ANALYTICS_SCRIPT_PATH}" data-site="platform"></script>`;

export function injectPlatformAnalyticsScript(html?: string): string | undefined {
  if (!html || html.includes(PLATFORM_ANALYTICS_SCRIPT_PATH)) return html;
  if (/<\/head\s*>/i.test(html)) {
    return html.replace(/<\/head\s*>/i, `  ${PLATFORM_ANALYTICS_SCRIPT_TAG}\n</head>`);
  }
  return `${PLATFORM_ANALYTICS_SCRIPT_TAG}\n${html}`;
}

export function registerPlatformAnalyticsRoutes(params: {
  app: {
    get(path: string, handler: (c: any) => Promise<Response | null> | Response | null): void;
    post(path: string, handler: (c: any) => Promise<Response | null> | Response | null): void;
  };
  functionsPath: string;
  rawSql: RawSql;
  analyticsRawSql?: RawSql;
  logger?: LoggerLike;
}): void {
  const serve = async (c: any) => {
    const analytics = await import(resolve(params.functionsPath, "analytics-platform.ts"));
    const host = c.req.header?.("host") ?? new URL(c.req.url).host;
    return await analytics.servePlatformAnalyticsRequest({
      c,
      host,
      rawSql: params.rawSql,
      analyticsRawSql: params.analyticsRawSql ?? params.rawSql,
      logger: params.logger,
    });
  };

  params.app.get(PLATFORM_ANALYTICS_SCRIPT_PATH, serve);
  params.app.post(PLATFORM_ANALYTICS_EVENT_PATH, serve);
}
